export { StudentQuestsPage } from "./StudentQuestsPage"
export type { StudentQuestsPageProps } from "./StudentQuestsPage"
